// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"236":"22a272e6","447":"a695eff4","998":"a2ef543c"}[chunkId] + ".chunk.css";
};